module.exports = __webpack_public_path__ + "static/media/adey-bennett-loop-1.31e8650d.jpg";